export default function DownLoadFile(
  arrayBuffer: ArrayBuffer,
  name: string,
): void {
  const url = window.URL.createObjectURL(new Blob([arrayBuffer]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
}
